<div class="container-margin desktop-view">
  <div class="row">
    <span class="bold xx-large-font">Supply Chain</span>
  </div>
  <div class="row margin-top-20">
    <span class="label">Provenance Description:</span>
    <span class="value">{{ supplyChain.provDescription }}</span>
  </div>
  <div class="row margin-top-20">
    <span class="label">Traced through Chain of Custody (CoC):</span>
    <span class="value">{{ supplyChain.tracedThroughCoc ? 'Yes' : 'No' }}</span>
  </div>
  <div class="row margin-top-20">
    <span class="label">Authenticated:</span>
    <span class="value">{{ supplyChain.isAuthenticated ? 'Yes' : 'No' }}</span>
  </div>
  <div class="row select-component-row">
    <mat-form-field appearance="outline" class="select-component">
      <mat-label>Component</mat-label>
      <mat-select [(value)]="selectedComponent" class="bold-select">
        @for (component of supplyChain.components; track component) {
          <mat-option [value]="component">{{ component.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="component-transactions">
    @for (
      transaction of selectedComponent.transactions;
      track transaction;
      let last = $last
    ) {
      <mat-divider></mat-divider>
      <div class="row trx-info-row">
        <span class="trx-name">{{ transaction.name }}</span>
        <span class="bold trx-company-name">{{ transaction.companyName }}</span>
        <span class="trx-open-trace">
          <a class="dark-link-underline" [routerLink]="['']">Open Trace</a>
          <mat-icon class="slant-arrow-icon">call_made</mat-icon>
        </span>
      </div>
      <mat-divider></mat-divider>
      @if (!last) {
        <div class="row">
          <mat-icon class="arrow-icon">arrow_downward</mat-icon>
        </div>
      }
    }
  </div>
</div>

<div class="container mobile-view">
  <mat-toolbar class="row product-name-navbar">
    <span class="bold-600 medium-font">{{ product.name }}</span>
  </mat-toolbar>
  <div class="info-container-mobile">
    <div class="row margin-top-20">
      <span class="bold x-large-font">Supply Chain</span>
    </div>
    <div class="row margin-top-20">
      <span class="light-bold">Provenance Description:</span>
    </div>
    <div class="row margin-top-10">
      <span>{{ supplyChain.provDescription }}</span>
    </div>
    <div class="row margin-top-20">
      <span class="light-bold">Traced through Chain of Custody (CoC):</span>
    </div>
    <div class="row margin-top-10 trx-open-trace-mobile">
      <span>{{ supplyChain.tracedThroughCoc ? 'Yes' : 'No' }}</span>
      <span class="open-trace-link-mobile">
        <a class="dark-link-underline" [routerLink]="['']">Open Trace</a>
        <mat-icon class="slant-arrow-icon">call_made</mat-icon>
      </span>
    </div>
    <div class="row margin-top-20">
      <span class="light-bold">Authenticated (Y/N):</span>
    </div>
    <div class="row margin-top-10">
      <span>{{ supplyChain.isAuthenticated ? 'Yes' : 'No' }}</span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-20">
      <mat-form-field appearance="outline" class="select-component-mobile">
        <mat-label>Component</mat-label>
        <mat-select [(value)]="selectedComponent" class="bold-select">
          @for (component of supplyChain.components; track component) {
            <mat-option [value]="component">{{ component.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <div class="component-transactions">
        @for (
          transaction of selectedComponent.transactions;
          track transaction;
          let last = $last
        ) {
          <mat-divider></mat-divider>
          <div class="row trx-info-row">
            <span class="trx-name">{{ transaction.name }}</span>
            <span class="bold trx-company-name">{{
              transaction.companyName
            }}</span>
            <span class="trx-open-trace">
              <a class="dark-link-underline" [routerLink]="['']">Open Trace</a>
              <mat-icon class="slant-arrow-icon">call_made</mat-icon>
            </span>
          </div>
          <mat-divider></mat-divider>
          @if (!last) {
            <div class="row">
              <mat-icon class="arrow-icon">arrow_downward</mat-icon>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
